export const getConsultationOrdersCounts = () => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/orders/admin/counts`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at orders ${e}`));
};
export const getConsultationOrdersByStatus = status => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/orders/admin/status?status=${status}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at orders ${e}`));
};
export const getConsultationOrderDetailsByOrderId = id => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/orders/admin/details/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at getting order ${e}`));
};
export const getOrderBySearch = search => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/orders/admin/search?search=${search}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at orders ${e}`));
};
export const RescheduleDocotorOrder = (body, id) => {
  console.log("Request Payload:", body);
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/orders/admin/reschedule/${id}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      console.log(res, "resssssssssss");
      return res.json();
    })
    .catch(e => console.log(`error at Service Update file field ${e}`));
};

export const CancelOrderByDoctor = (OrderId, body) => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/orders/doctor/cancel/${OrderId}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at Admin Notes Update ${e}`));
};